import Vue from "vue";
import Buefy from "buefy";

import { library } from "@fortawesome/fontawesome-svg-core";

// internal icons
import {
    faCheck,
    faCheckCircle,
    faInfoCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faArrowUp,
    faAngleRight,
    faAngleUp,
    faAngleLeft,
    faAngleDown,
    faEye,
    faEyeSlash,
    faCaretDown,
    faCaretUp,
    faUpload,
    faCopy,
    faTrashAlt,
    faTrash,
    faEdit,
    faCloud,
    faCloudUploadAlt,
    faCloudDownloadAlt,
    faTimes,
    faTimesCircle,
    faPlus,
    faMinus,
    faBellSlash,
    faImage,
    faCircle,
    faSearch,
    faFileAlt,
    faRecycle,
    faUsers,
    faUserCircle,
    faSortAmountDown,
    faSortAmountUp,
    faBell,
    faBox,
    faShoppingCart,
    faChartPie,
    faPrint,
    faCog
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
    faCheck,
    faCheckCircle,
    faInfoCircle,
    faExclamationTriangle,
    faExclamationCircle,
    faArrowUp,
    faAngleRight,
    faAngleLeft,
    faAngleDown,
    faAngleUp,
    faEye,
    faEyeSlash,
    faCaretDown,
    faCaretUp,
    faUpload,
    faCopy,
    faTrashAlt,
    faTrash,
    faEdit,
    faCloud,
    faCloudUploadAlt,
    faCloudDownloadAlt,
    faTimes,
    faTimesCircle,
    faPlus,
    faMinus,
    faBellSlash,
    faBell,
    faImage,
    faCircle,
    faSearch,
    faFileAlt,
    faRecycle,
    faUsers,
    faUserCircle,
    faSortAmountDown,
    faSortAmountUp,
    faShoppingCart,
    faBox,
    faChartPie,
    faPrint,
    faCog
);
Vue.component("vue-fontawesome", FontAwesomeIcon);

// import Card from "@/components/bulma/Card.vue";
import Modal from "@/components/bulma/formModal.vue";

// // Adiciona os componentes complementares
// Vue.component("b-card", Card);
Vue.component("b-form-modal", Modal);

// Configura o bulma
export default Vue.use(Buefy, {
    defaultIconComponent: "vue-fontawesome",
    defaultIconPack: "fas",
    defaultDayNames: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    defaultMonthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ]
});
